import { type ComputedRef, computed } from 'vue';

import { useUserInterfaceSettingsStore } from 'src/stores/userInterfaceSettings';

interface IconClassApi {
	iconClass: (icon: string) => string;
	prefix: ComputedRef<string>;
	solid: ComputedRef<boolean>;
}

export function useIconClass(): IconClassApi {
	const store = useUserInterfaceSettingsStore();

	const solid = computed((): boolean => store.menuItemsSolid);
	const prefix = computed((): string => (solid.value ? 'fa-solid' : 'fa-regular'));

	const iconClass = (icon: string): string => `${prefix.value} ${icon}`;

	return { iconClass, prefix, solid };
}
